import { IoCartSharp } from "react-icons/io5";
import { ROUTES } from "../../routes";
import { useNavigate } from "react-router-dom";

const CartBottomComponent = () => {
  const navigate = useNavigate();
  
  return (
    <div
      onClick={() => navigate(ROUTES.CART)}
      className="fixed bottom-5 right-5 md:bottom-8 md:right-10 bg-primary-500 rounded-full p-4 cursor-pointer z-20 border-2 border-primary-700 shadow-md hover:bg-primary-600 hover:shadow-lg hover:scale-105 transition-transform"
      title="Ver carrinho"
    >
      <IoCartSharp size={32} color="white" />
    </div>
  );
};

export default CartBottomComponent;
